import PopupTemplate from '@arcgis/core/PopupTemplate.js';
import type { LayerProbe, LayerRecord } from './types';

export function buildPopupTemplate(record: LayerRecord): PopupTemplate {
  const probe = record.probe;
  const titleField = probe?.service.display_field ?? probe?.service.object_id_field;
  const title = titleField ? `${record.id} · {${titleField}}` : record.id;

  if (!probe) {
    return new PopupTemplate({ title, content: '{*}' });
  }

  const fieldInfos = pickFieldInfos(probe);
  if (fieldInfos.length === 0) {
    return new PopupTemplate({ title, content: '{*}', outFields: ['*'] });
  }

  return new PopupTemplate({
    title,
    outFields: ['*'],
    content: [{ type: 'fields', fieldInfos }],
  });
}

function pickFieldInfos(probe: LayerProbe): Array<{ fieldName: string; label: string }> {
  return probe.fields
    .filter((f) => !f.dead)
    .filter((f) => !isHeavy(f.type))
    .map((f) => ({ fieldName: f.name, label: f.alias ?? f.name }));
}

function isHeavy(type: string): boolean {
  return (
    type === 'esriFieldTypeBlob' ||
    type === 'esriFieldTypeRaster' ||
    type === 'esriFieldTypeXML' ||
    type === 'esriFieldTypeGeometry'
  );
}
